<template>
  <div class="DoNotTrack">
    <h2 class="DoNotTrack_Heading">NOTICE CONCERNING DO NOT TRACK</h2>
    <p>
      Do Not Track (<strong>“DNT”</strong>) is a privacy preference that users
      can set in certain web browsers. We are committed to providing you with
      meaningful choices about the information collected on our websites for
      third-party purposes, and that is why we provide the variety of opt-out
      mechanisms listed above, and in our Cookies Notice. Some web browsers
      offer users a “Do Not Track” privacy preference setting in the web
      browser. We do not currently recognize or respond to browser-initiated Do
      Not Track signals. Learn more about Do Not Track at
      <SkyLink to="https://allaboutdnt.com/" inline tag="a" target="_blank"
        >allaboutdnt.com</SkyLink
      >.
    </p>
  </div>
</template>

<style lang="scss">
.DoNotTrack {
  display: grid;
  row-gap: var(--spacing-3x);

  &_Heading {
    @include type-brand-heading('2');
    margin-top: var(--spacing-8x);
  }
}
</style>
